<template>
  <div class="element-item">
    <div class="element-group flex justify-between items-center mb-4">
      <div class="text-xl">
        {{$t(`client.${element.element_group_slug||element.group_slug}.title`)}}
      </div>
      <div
        v-if="element.total && settings.with_calc_price == 1 && !isComplectation"
        class="font-bold text-xl mt-2 text-right"
      >
        {{ $toCurrency(element.total) }}
      </div>
      <button
        v-if="isComplectation"
        class="font-light"
        @click="
                  $store.dispatch(
                    'clientOrder/removeElement',
                    element.element_id
                  )
                "
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="element-detail">
      <div class="image">
        <div class="image-wrapper">
          <div
            class="image-src"
            :style="{ backgroundImage: `url(${element.image||element.thumb})` }"
          ></div>
        </div>
      </div>
      <div class="detail w-full text-sm">
        <div>
          <span class="font-bold">{{$t('main.name')}}: </span>
          <span>{{ element.name }}</span>
        </div>
        <div>
          <span class="font-bold">{{$t('main.article')}}: </span>
          <span>{{ element.article }}</span>
        </div>
        <div>
          <span class="font-bold">{{$t('main.type')}}: </span>
          <span>{{ element.type_name||element.type }}</span>
        </div>
        <div v-if="element.material||(element.material_name&&element.material_name!='0')">
          <span class="font-bold">{{$t('main.material')}}: </span>
          <span>{{ element.material?element.material.name:element.material_name }}</span>
        </div>
        <div v-if="element.size">
          <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
          <span>{{ element.size.height }} x {{ element.size.width }} x {{ element.size.length }}
          </span>
        </div>
        <div v-if="element.depth||element.height||element.width">
          <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
          <span>{{ element.height }} x {{ element.width }} x {{ element.depth }}</span>
        </div>
        <div v-if="(element.size && element.size.weight) || element.weight">
          <span class="font-bold">{{$t('main.weight_kg')}}:
          </span>
          <span>{{ ((element.size && element.size.weight)||element.weight) }}
          </span>
        </div>
        <div v-if="((element.size && element.size.cost_coefficient) || element.size_coef) && settings.with_calc_price == 1">
          <span class="font-light text-gray-600 italic text-xs">{{$t('main.additional_cost')}}:
          </span>
          <span class="text-gray-600 italic">{{ $toCurrency(((element.size && element.size.cost_coefficient)||element.size_coef)) }}
          </span>
        </div>

        <div
          v-if="element.polish"
          class="additional-works-element"
        >
          <div class="font-bold">{{$t('main.polish')}}: </div>
          <div>{{element.polish.name}}</div>
        </div>
        <div
          v-if="angleDegree"
          class="additional-works-element"
        >
          <div class="font-bold">{{$t('main.rotate')}}: </div>
          <div>{{ angleDegree }}&deg;</div>
        </div>
        <div
          v-if="element.services&&element.services.length>0"
          class="additional-works-element"
        >
          <div class="additional-works-element__name font-bold">{{$t('main.services')}}: </div>
          <div>
            <div
              class="additional-works-element__position"
              v-for="service in element.services"
              :key="`complectation-service-${service.id}`"
            >{{service.name}}</div>

          </div>
        </div>
        <div
          v-if="element.total && settings.with_calc_price == 1 && isComplectation"
          class="font-bold text-xl mt-2 text-right"
        >
          {{ $toCurrency(element.total) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAngleDegree } from "../../utils/calcAngle";
export default {
  props: {
    element: {
      type: Object,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    isComplectation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    angleDegree() {
      if (parseFloat(this.element.rotate)) {
        return getAngleDegree(this.element.rotate);
      }
      return null;
    },
  },
};
</script>

<style scoped>
.element-detail {
  display: flex;
  gap: 1rem;
}

@media screen and (max-width: 1000px) {
  .element-detail {
    flex-direction: column;
  }
}
</style>

